import React from "react";


import {
  Card,
  CardBody,
  Content,
  Grid,
  GridItem,
  List,
  ListItem,
  PageSection,
  Stack,
  StackItem,
  Flex,
  FlexItem
} from "@patternfly/react-core";


import {
  ExternalLinkAltIcon
} from "@patternfly/react-icons";


import {
  maturaDocuments
} from "./data/maturaDocuments";


const MaturaPage = () => {
  return (
    <PageSection isWidthLimited>
      <Stack hasGutter>
        <StackItem>
          <Grid>
            <GridItem span={12} md={8} mdOffset={2}>
              <Content style={{ textAlign: "center" }}>
                <h1>Egzamin maturalny</h1>

                <p>
                  Dokumenty i informacje dotyczące egzaminu maturalnego.
                </p>
              </Content>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={10}
              mdOffset={1}
              lg={8}
              lgOffset={2}
            >
              <Card isGlass>
                <CardBody>
                  <Stack hasGutter>
                    <StackItem>
                      <Flex
                        justifyContent={{ default: "justifyContentSpaceBetween" }}
                        alignItems={{ default: "alignItemsCenter" }}
                        style={{ width: "100%" }}
                      >
                        <FlexItem>
                          <Content>
                            <h2 style={{ marginBottom: 0 }}>
                              Matura 2027
                            </h2>
                          </Content>
                        </FlexItem>

                        <FlexItem>
                          <p
                            style={{
                              marginBottom: 0,
                              color: "var(--pf-t--global--text--color--subtle)",
                              fontSize: "var(--pf-t--global--font--size--sm)",
                              textAlign: "right"
                            }}
                          >
                            Ostatnia aktualizacja:{" "}
                            <time dateTime="2026-09-08">
                              8 września 2026 r.
                            </time>
                          </p>
                        </FlexItem>
                      </Flex>
                    </StackItem>

                    <StackItem>
                      <Content>
                        <List isPlain>
                          {maturaDocuments.map((document) => (
                            <ListItem key={document.id}>
                              <a
                                href={document.href}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {document.title}{" "}
                                <ExternalLinkAltIcon />
                              </a>
                            </ListItem>
                          ))}
                        </List>
                      </Content>
                    </StackItem>
                  </Stack>
                </CardBody>
              </Card>
            </GridItem>
          </Grid>
        </StackItem>
      </Stack>
    </PageSection>
  );
};


export default MaturaPage;